import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import CheckIsEmailVerified from '../../DataStore/Hooks/CheckIsEmailVerified';
import axios from 'axios';
import CustomAlert from '../CustomAlert';
import mapValues from 'lodash/mapValues';
import db, { auth } from '../../Backend/firebase/firebase';
import { ContentState, convertToRaw, EditorState, convertFromHTML } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import { Helmet } from 'react-helmet';
import CheckUserProvider from '../../AllHooks/CheckUserProvider';
import { uploadImageInBase64 } from '../../Backend/firebase/user';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { sleep, resizeFileImage } from '../Models/CommonFunc';

const useStyles = makeStyles((theme) => ({
    root: {

    },
}));

function UpdateProfile() {
    const classes = useStyles();
    const { userData } = CheckUserProvider();
    console.log('userData',userData)
    const { register, handleSubmit, errors, setValue } = useForm();
    const [detactCountry, setDetactCountry] = useState({
        countryName: '',
        countryCode: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const isEmailVerified = CheckIsEmailVerified();
    const [verifyCaptcha, setVerifyCaptcha] = useState(false);
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [previousEmail, setPreviousEmail] = useState('');
    const [previousName, setPreviousName] = useState('');
    const [ProductDescription, setProductDescription] = useState(() => EditorState.createEmpty());
    const fileInput = useRef(null);
    const [retailerImageUrl, setRetailerImageUrl] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [homeDelivery, setHomeDelivery] = useState('Select Option');
    const [areaCovers, setAreaCovers] = useState('Select Option');

    useEffect(async () => {
        if(userData) {
            setTimeout(() => {
                mapValues(userData, (value, key) => setValue(key, value));
            });
            setPreviousEmail(userData.email);
            setPreviousName(userData.name);
            setHomeDelivery(userData?.homeDelivery ? userData?.homeDelivery : 'Select Option')
            setAreaCovers(userData?.areaCovers ? userData?.areaCovers : 'Select Option')
            userData?.remarks && setProductDescription(EditorState.createWithContent
                (ContentState.createFromBlockArray(convertFromHTML
                    (draftToHtml(JSON.parse(userData.remarks))))));
            if (userData?.country)
                setValue('country', userData.country);
            else
                getGeoInfo();
        }
    }, [userData]);

    const getGeoInfo = () => {
        axios.get('https://ipapi.co/json/').then((response) => {
            let data = response.data;
            setDetactCountry({
                countryName: data.country_name,
                countryCode: data.country_calling_code
            });
            setValue('country', data.country_name);
        }).catch((error) => {
            console.log(error);
        });
    };

    const handleCaptchaOnLoad = () => {
        console.log('Captcha load successfully.');
    };

    const handleCaptchaVerification = (response) => {
        if (response) {
            setVerifyCaptcha(true);
        }
        else {
            setVerifyCaptcha(false);
        }
    };

    const onSubmit = async (data) => {
        setIsLoading(true);
        // if (verifyCaptcha) {
            try {
                const value = convertToRaw(ProductDescription.getCurrentContent());
                var user = auth.currentUser;
                if (user) {
                    if (previousName?.toLowerCase() !== data?.storeName?.toLowerCase()) {
                        console.log('Data Updated in firebase');
                        //await user.updateEmail(data.email);
                        await user.updateProfile({ displayName: data?.storeName });
                    }
                    try {
                        const docRef = db.doc(`/Users/${user?.uid}`);
                        await docRef.update({
                            name: data.storeName,
                            storeName: data.storeName,
                            businessType: data.businessType,
                            storeAddress: data.storeAddress,
                            storeCity: data.storeCity,
                            zipcode: data.zipcode,
                            gstNo: data.gstNo,
                            drugLicense: data.drugLicense,
                            remarks: String(JSON.stringify(value)),
                            phoneNumber: data.phoneNumber,
                            storeWebsite: data.storeWebsite,
                            country: 'India',
                            homeDelivery: homeDelivery,
                            areaCovers: homeDelivery == "No" ? 'Select Option' : areaCovers,
                            retailerImage: retailerImageUrl
                        });
                        
                        setNotificationMessage('Profile updated successfully.');
                        setOpenNotify(true);
                        setAlertType('success');
                        setIsLoading(false);
                        window.location.reload(true);
                    } catch(error) {
                        console.log("Error Occur in Update Profile : ", error)
                    }
                }
            } catch (err) {
                console.log(err);
                if (err.code === 'auth/requires-recent-login') {
                    setNotificationMessage('To change the email, please logout your account and login again!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsLoading(false);
                } else {
                    setNotificationMessage('Something goes wrong!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsLoading(false);
                }
            }
        // } else {
        //     setNotificationMessage('Please verify the captcha first!');
        //     setOpenNotify(true);
        //     setAlertType('error');
        //     setIsLoading(false);
        // }
        setIsLoading(false);
    };

    const onEditorStateChange = (editorState) => {
        setProductDescription(editorState);
    };

    const fileChange = async (files) => {
        try {
            setIsUploading(true);
            var newFileImage = await resizeFileImage(files[0]);
            const ref = await uploadImageInBase64(userData.uid,
                newFileImage.substring(22),
                updateProgress);
            const downloadUrl = await ref.getDownloadURL();
            setRetailerImageUrl(downloadUrl);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
        }
    }

    const updateProgress = (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(progress);
    }

    return (
        <>
            <div className={classes.root}>
                <Helmet>
                    <meta name="description" content="Use this page to update retailer profile" />
                    <title>Update Profile | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="updateEmpProfile">
                    {!userData ?
                        (<div className="row">
                            <div className="col-md-12 text-center p-4">
                                <CircularProgress />
                            </div>
                        </div>) : <div className="companyProfile company__profile background__black__color">
                            <div className="row mt-2">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">
                                        <h5 className="mt-3 text__white__color">Profile</h5>
                                        <div className="col-md-6 col-sm-12 mb-2">
                                            <div className="form-group">
                                                <label className="login__textboxLabel">Business Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.storeName })}
                                                    name="storeName" placeholder="Business Name" autoComplete="off"
                                                    ref={register({ required: 'Please enter your Business Name!' })} />
                                                <small className="form-text text-danger">{errors.storeName && errors.storeName.message}</small>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-12 mb-2">
                                            <div className="form-group">
                                                <label className="login__textboxLabel">Email Address <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                                <input type="email" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.email })}
                                                    name="email" placeholder="Email Address" autoComplete="none"
                                                    ref={register({ required: 'Please enter your name!' })} disabled />
                                                <small className="form-text text-danger">{errors.email && errors.email.message}</small>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-12 pt-2 mb-2">
                                            <div className="form-group">
                                                <label className="login__textboxLabel form__label">Business Type <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                                <select className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.businessType })} aria-label="Default select example"
                                                    name="businessType" ref={register({ required: 'Please Select Business Type!' })} defaultValue="Select Option">
                                                    <option value="Select Option">Select Option</option>
                                                    <option value="Manufacturer">Manufacturer</option>
                                                    <option value="Third Party Manufacturing Comapny or Marketer">Third Party Manufacturing Comapny or Marketer</option>
                                                    <option value="Distributor">Distributor</option>
                                                    <option value="Wholesaler">Wholesaler</option>
                                                    <option value="Chemist store or retailer">Chemist store or retailer</option>
                                                </select>
                                                <small className="form-text text-danger">{errors.businessType && errors.businessType.message}</small>
                                            </div>
                                        </div>
                                        {/* <div className="col-md-4 mb-2">
                                            <div className="form-group">
                                                <label className="login__textboxLabel">Chemist Shop Logo</label>
                                                <div className="d-flex align-items-center">
                                                    <input type="file" accept=".png,.jpg,.jpeg" ref={fileInput}
                                                        onChange={(e) => fileChange(e.target.files)} style={{ display: 'none' }} />
                                                    <Button
                                                        variant="contained"
                                                        color="default"
                                                        startIcon={<CloudUploadIcon />}
                                                        onClick={() => fileInput.current.click()}>
                                                        {isUploading ? <CircularProgress variant="determinate"
                                                            value={uploadProgress} size={25} />
                                                            : 'Upload'}
                                                    </Button>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="col-md-6 col-sm-12 pt-1 mb-2">
                                            <div className="form-group">
                                                <label className="login__textboxLabel form__label">Your City <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                                <select className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.zipcode })} aria-label="Default select example"
                                                    name="storeCity" ref={register({ required: 'Please Select Your City!' })} defaultValue="Select Option">
                                                    <option value="">Select Option</option>
                                                    <option value="Patna">Patna</option>
                                                    <option value="Ara">Ara</option>
                                                    <option value="Motihari">Motihari</option>
                                                    <option value="Delhi">Delhi</option>
                                                </select>
                                                <small className="form-text text-danger">{errors.storeCity && errors.storeCity.message}</small>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-12 mb-2">
                                            <div className="form-group">
                                                <label className="login__textboxLabel">Zipcode <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.zipcode })}
                                                    name="zipcode" placeholder="Zipcode" autoComplete="none" maxLength="6" minLength="4"
                                                    ref={register({
                                                        required: 'Please enter your zipcode!',
                                                        minLength: {
                                                            value: 4,
                                                            message: 'Zipcode should be at least 6 characters!'
                                                        },
                                                        maxLength: {
                                                            value: 6,
                                                            message: 'Zipcode should be 6 length maximum!'
                                                        }
                                                    })}
                                                />
                                                <small className="form-text text-danger">{errors.zipcode && errors.zipcode.message}</small>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-12 mb-2">
                                            <div className="form-group">
                                                <label className="login__textboxLabel">Address <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.storeAddress })}
                                                    name="storeAddress" placeholder="Address" autoComplete="none"
                                                    ref={register({ required: 'Please enter your address!' })} />
                                                <small className="form-text text-danger">{errors.storeAddress && errors.storeAddress.message}</small>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-12 mb-2">
                                            <div className="form-group">
                                                <label className="login__textboxLabel">GST No </label>
                                                <input type="text" className={classNames("form-control registerEmp__textbox")}
                                                    name="gstNo" placeholder="GST No" autoComplete="none"
                                                    ref={register}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-12 mb-2">
                                            <div className="form-group">
                                                <label className="login__textboxLabel">Drug License </label>
                                                <input type="text" className={classNames("form-control registerEmp__textbox")}
                                                    name="drugLicense" placeholder="Drug License" autoComplete="none"
                                                    ref={register} />
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-12 mb-2">
                                            <div className="form-group">
                                                <label className="login__textboxLabel">Your Phone Number <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.phoneNumber })}
                                                    name="phoneNumber" placeholder="Phone Number" autoComplete="none"
                                                    maxLength="15" minLength="10"
                                                    ref={register({
                                                        required: 'Please enter your phone number!',
                                                        minLength: {
                                                            value: 10,
                                                            message: 'Phone number should be at least 10 digits!'
                                                        },
                                                        maxLength: {
                                                            value: 15,
                                                            message: 'Phone number should be 10 length maximum!'
                                                        }
                                                    })} />
                                                <small className="form-text text-danger">{errors.phoneNumber && errors.phoneNumber.message}</small>
                                            </div>
                                        </div>
                                        {/* <div className="col-md-6 col-sm-12 mb-2">
                                            <label className="login__textboxLabel">Your Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                            <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.name })}
                                                name="name" placeholder="Name" autoComplete="off"
                                                ref={register({ required: 'Please enter your name!' })} />
                                            <small className="form-text text-danger">{errors.name && errors.name.message}</small>
                                        </div> */}
                                        <h5 className="mt-3 text__white__color mb-2">Additional information</h5>
                                        <div className="col-md-12 mb-2">
                                            <div className="form-group">
                                                <div className="row">
                                                    <div className="col-md-4 mb-2">
                                                        <div className="form-group">
                                                            <label className="login__textboxLabel">Website</label>
                                                            <input type="text" className={classNames("form-control registerEmp__textbox")}
                                                                name="storeWebsite" placeholder="Website" autoComplete="none"
                                                                ref={register} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4 col-sm-14 pt-1">
                                                        <label className="login__textboxLabel">Home Delivery</label>
                                                        <select className="form-select registerEmp__textbox" aria-label="Default select example"
                                                            name="homeDelivery" ref={register} 
                                                            defaultValue="Select Option"
                                                            onChange={(event)=> setHomeDelivery(event.target.value)}>
                                                            <option value="Select Option">Select Option</option>
                                                            <option value="Yes">Yes</option>
                                                            <option value="No">No</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-4 col-sm-12">
                                                        <label className="login__textboxLabel">Area Covers</label>
                                                        <select className="form-select registerEmp__textbox" aria-label="Default select example"
                                                            name="areaCovers" ref={register} 
                                                            value={homeDelivery == "No" ? "Select Option" : areaCovers}
                                                            defaultValue="Select Option"
                                                            disabled={homeDelivery == "No"}
                                                            onChange={(event)=> setAreaCovers(event.target.value)}>
                                                            <option value="Select Option">Select Option</option>
                                                            <option value="1KM">1KM</option>
                                                            <option value="2KM">2KM</option>
                                                            <option value="3KM">3KM</option>
                                                            <option value="2KM">2KM</option>
                                                            <option value="5KM">5KM</option>
                                                            <option value="10KM">10KM</option>
                                                            <option value="Across The City">Across The City</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-2">
                                            <div className="createProduct__RictTextEditor">
                                                <label className="login__textboxLabel">Store description</label>
                                                <Editor editorState={ProductDescription} onEditorStateChange={onEditorStateChange}
                                                    className="createProduct__editorCss"
                                                    toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                                    editorClassName="editorClassName" />
                                            </div>
                                        </div>
                                        <div className="col-sm-12 text-right mt-2">
                                            <div className="d-flex justify-content-center">
                                                <div className="p-2">
                                                        <Button
                                                            type="submit"
                                                            variant="contained"
                                                            color="primary"
                                                            size="small"
                                                            className="login__btn sign-up__submit update__profile"
                                                        >
                                                            {isLoading ? (
                                                            <CircularProgress size={18} />
                                                            ) : (
                                                            'Update Profile'
                                                            )}
                                                        </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    }
                </div>
            </div>

            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default UpdateProfile
